import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import Security from '../../commons/security/Security.js'
import 'bootstrap4-duallistbox'
import 'bootstrap4-duallistbox/dist/bootstrap-duallistbox.css'
import FormValidation from '../../commons/validation/FormValidation.js'
import Validator from '../../commons/validation/Validator.js'
import AjaxHandler from '../../commons/ajax/AjaxHandler.js'
import Loading from '../ui/Loading.js'
import Select from 'react-select'
import 'react-select/dist/react-select.css'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import 'moment/min/locales'
import 'react-datepicker/dist/react-datepicker.css'
import Switch from "react-switch"
import {FormattedMessage, injectIntl} from 'react-intl';
import backendStrings from '../../lang/backendStrings.js';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';
import LocaleFormat from '../../commons/utils/LocaleFormat.js';

class FormularioRecurrenciaAbm extends Component {
  constructor(props) {
    super(props);
    this.ajaxHandler = new AjaxHandler();
    moment.locale('es');
    this.state = {
      redirectTo: null,
      props: this.props,
      formData: {
        id: 0,
        tipo_formulario: null,
        persona: null,
        movil: null,
        fecha_vencimiento: null,
        recurrencia: null,
        fechaVencimientoInvalida:false,
        alerta_dias_previos: 0,
        activo: true,
        renovacion: true
      },
      errors: [],
      loading: false,
      isInvalidActivo: false,
    };

    this.handleActivoChange = this.handleActivoChange.bind(this);
    this.handleRenovacionChange = this.handleRenovacionChange.bind(this);
    this.handleFormChangeSelectObject = this.handleFormChangeSelectObject.bind(this);
    this.handleDatePickerFormChange = this.handleDatePickerFormChange.bind(this);
    this.handleMovilChange = this.handleMovilChange.bind(this);
    this.getBackendMoviles = this.getBackendMoviles.bind(this);
    this.getBackendTipoForms = this.getBackendTipoForms.bind(this);
    this.handlePersonaChange = this.handlePersonaChange.bind(this);
    this.getBackendPersonas = this.getBackendPersonas.bind(this);
    this.handleTipoFormularioChange = this.handleTipoFormularioChange.bind(this);
    this.handleTicketChange = this.handleTicketChange.bind(this);
    this.getBackendTickets = this.getBackendTickets.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.formValidation = new FormValidation({
      component: this,
      validators: {
        'formData.tipo_formulario': (value) => Validator.notEmpty(value),
        'formData.recurrencia': (value) => Validator.notEmpty(value),
        'formData.fecha_vencimiento': (value) => Validator.date(value) && Validator.notEmpty(value),
      }
    });
  }

  componentWillMount() {
    this.ajaxHandler.subscribe(this);
    this.initForm();
  }

  componentWillUnmount() {
    this.ajaxHandler.unsubscribe();
  }

  initForm() {
    if (ConfigBusiness.get("checklist_recurrencia.habilitado") === 'true') {
      if(this.state.props.action === 'VIEW' || this.state.props.action === 'EDIT') this.loadFormData();
      window.scrollTo(0, 0);
    } else {
      this.setState({
        redirectTo: '/error'
      });
    }
  }

  loadFormData() {
    let component = this;
    this.setState({ loading: true });
    this.ajaxHandler.getJson('/formulario-recurrencias/' + this.state.props.match.params.id)
    .then(data => {
      if(data){
        if(data.entidad_type === "Vecfleet\\Api\\Model\\Movil"){
          data.movil = data.entidad;
        }else if(data.entidad_type === "Vecfleet\\Api\\Model\\Persona"){
          data.persona = data.entidad;
        }
        if(this.state.props.action === 'EDIT'){
          let key_validator = '';
          if (data.tipo_formulario && data.tipo_formulario.con_movil) {
            key_validator = 'formData.movil';
          }else if(data.tipo_formulario && data.tipo_formulario.con_persona){
            key_validator = 'formData.persona';
          }else if(data.tipo_formulario && data.tipo_formulario.con_ticket){
            key_validator = 'formData.ticket';
          }
          let validator = {}
          validator['formData.fecha_vencimiento'] = (value) => Validator.notEmpty(value) && Validator.date(value)
          validator['formData.tipo_formulario'] = (value) => Validator.notEmpty(value)
          validator['formData.recurrencia'] = (value) => Validator.notEmpty(value)

          validator[key_validator] = (value) => Validator.notEmpty(value)
          this.formValidation = new FormValidation({
            component: this,
            validators: validator
          });
        }

        component.setState({
          formData: Object.assign(this.state.formData, data)
        }, () =>{
          
        });
      }
    }).finally(() => {
      this.setState({ loading: false });
    });
  }

  handleFormChangeSelectObject(name, object) {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy[name] = object ? { id: object.value } : null;
    this.setState({
      formData: formDataCopy
    });
  }

  handleMovilChange(movil) {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy["movil"] = movil;
    this.setState(
      { formData: formDataCopy },
      () => {
        this.validaActivo();
      }
    );
  }

  handlePersonaChange(persona) {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy["persona"] = persona;
    this.setState({
      formData: formDataCopy,
    });
  }

  handleTicketChange(ticket) {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy["ticket"] = ticket;
    this.setState({
      formData: formDataCopy
    });
  }

  handleActivoChange(activo) {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
      formDataCopy.activo = activo;
      this.setState({
        formData: formDataCopy
    }, () => {this.validaActivo();});
  }

  handleRenovacionChange(renovacion) {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
      formDataCopy.renovacion = renovacion;
      this.setState({
          formData: formDataCopy
    });
  }

  handleDatePickerFormChange(name, event) {
    let date = event ? event.format(): '';
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy['fechaVencimientoInvalida'] = false;
        formDataCopy[name] = date;
        this.setState({
            formData: formDataCopy
        });
  }

  handleDatePickerFormRawChange(name, date) {
    console.log(name);
    let formatDate;
    let datefinal;
    formatDate= new Intl.DateTimeFormat('en-GB',{day:'2-digit',month:'2-digit',year:'numeric'})
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    if( new Date(date) == "Invalid Date" || date.length < 8) {
      formDataCopy[name] = '';
      if (name == "fecha_vencimiento"){
        formDataCopy['fechaVencimientoInvalida'] = true;
        if(date.length == 10 ) {
          formDataCopy['fechaVencimientoInvalida'] = false;
          this.setState({
            formData: formDataCopy
          });
        } else {
          formDataCopy['fechaVencimientoInvalida'] = true;
          this.setState({
            formData: formDataCopy
          });
        } 
      }
    } else{
      datefinal = formatDate.format(new Date(date));
      let mesConvertido = datefinal.toString();
      let mes;
      mes = mesConvertido.substr(0,2);
      
      if( mes > 12 ) {
        formDataCopy[name] = '';
        if (name == "fecha_vencimiento"){formDataCopy['fechaVencimientoInvalida'] = true;}
      } else {
        formDataCopy[name] = datefinal;
        if (name == "fecha_vencimiento"){formDataCopy['fechaVencimientoInvalida'] = false;}
      }

      this.setState({
        formData: formDataCopy
      });
    }
  }

  getBackendTipoForms (searchTerm) {
		return this.ajaxHandler.getJson('/tipoformulario/simple-search?search=' + searchTerm).then(res => {
      // Filtra y deja de lado los tipos de formulario que solo pueden ser usados en la APP
      res = res.filter(option => option.exclusivoApp === 0);
			return {
				options: res,
				complete: true
			}
		});
	}

  handleNumericChange(e) {
    let name = e.target.name;
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    let value = e.target.value;
    if (name === 'recurrencia' || name === 'alerta_dias_previos') {
      value = value === '' ? null : parseInt(value, 10);
    }
    formDataCopy[name] = (e.target.validity.valid) ? value : this.state.formData[name];
    this.setState({
      formData: formDataCopy
    });
  }

  getBackendMoviles(searchTerm) {
    return this.ajaxHandler.getJson("/moviles/simple-search?search=" + searchTerm).then((res) => {
      if (Security.hasPermission('USUARIO_POSEER_MOVIL')){
        this.handleMovilChange(res[0]);
      } 
      return {
        options: res,
        complete: true,
      };
    });
  }

  getBackendPersonas(searchTerm) {
    return this.ajaxHandler.getJson(`/personas/simple-search?filterNotInternal=true&search=${searchTerm}&active=1&total=all`).then((res) => {
      if (Security.hasPermission('USUARIO_POSEER_MOVIL')){
        this.handlePersonaChange(res[0]);
      } 
      return {
        options: res,
        complete: true,
      };
    });
  }

  getBackendTickets (searchTerm) {
		return this.ajaxHandler.getJson('/tickets/simple-search?&number=10&search=' + searchTerm).then(res => {
			return {
				options: res,
				complete: true
			}
		});
	}

  handleTipoFormularioChange(tipo_formulario) {
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy.movil = null;
		formDataCopy.persona = null;
		formDataCopy.tipo_formulario = tipo_formulario;
		
		let key_validator = '';
    if (tipo_formulario && tipo_formulario.con_movil) {
      key_validator = 'formData.movil';
    }else if(tipo_formulario && tipo_formulario.con_persona){
      key_validator = 'formData.persona';
    }
		let validator = {}
    validator['formData.fecha_vencimiento'] = (value) => Validator.date(value) &&Validator.notEmpty(value)
		validator['formData.tipo_formulario'] = (value) => Validator.notEmpty(value)
    validator['formData.recurrencia'] = (value) => Validator.notEmpty(value)

		validator[key_validator] = (value) => Validator.notEmpty(value)
		this.formValidation = new FormValidation({
			component: this,
			validators: validator
    });
		this.setState({
			formData: formDataCopy,
      entidad: null,
		});
	}

  handleSubmit(event) {
    this.setState({ loading: true });
    let component = this;
    this.state.formData.tipo_formulario_id = this.state.formData.tipo_formulario ? this.state.formData.tipo_formulario.id : null;
    this.state.formData.movil_id = this.state.formData.movil ? this.state.formData.movil.id : null;
    this.state.formData.persona_id = this.state.formData.persona ? this.state.formData.persona.id : null;
    this.state.formData.ticket_id = this.state.formData.ticket ? this.state.formData.ticket.id : null;
    this.state.formData.alerta_dias_previos = this.state.formData.alerta_dias_previos ? this.state.formData.alerta_dias_previos : 0;
     this.state.formData.fecha_vencimiento = moment(this.state.formData.fecha_vencimiento).format('YYYY-MM-DD 00:00:00');
    this.ajaxHandler.fetch('/formulario-recurrencias' + (this.props.action === 'ADD' ? '' : '/' + this.state.formData.id), {
      method: this.props.action === 'ADD' ? 'POST' : 'PUT',
      body: JSON.stringify({
        ...this.state.formData
      }),
    })
    .then(response => {
      if(response.status !== 400) {
        component.exit();
      } else {
        response.json()
        .then(data => {
          this.setState({
            errors: data.detalle
          });
        });
      }
      window.scrollTo(0,0);
    })
    .catch((error) => {
      this.ajaxHandler.handleError(error);
    })
    .finally(() => {
      this.setState({ loading: false });
    });
    event.preventDefault();
  }

  handleCancel(event) {
    this.exit();
  }

  exit() {
    this.setState({
      redirectTo: '/formulario-recurrencias'
    });
  }

  validaActivo() {
    const isMovilActive = this.state.formData.movil && this.state.formData.movil.activo!== 0;
    const isFormularioActivo = this.state.formData.activo;
    if ( !isMovilActive && isFormularioActivo) {
      this.setState({
        isInvalidActivo: true,});
    }else {
      this.setState({
        isInvalidActivo: false,
      });
    }
  }

  render() {
    this.formValidation.validate();
    let state = this.state;
    let formData = this.state.formData;
    let validationState = this.formValidation.state;
    let isInvalidActivo = this.state.isInvalidActivo;
    let requiredSymbol = state.props.action !== 'VIEW' ? ' *' : '';

    const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
      <input
        className="form-control date-picker-placeholder"
        onClick={onClick}
        value={value}
        readOnly
        ref={ref}
        style={{ backgroundColor: '#fff', cursor: 'pointer' }}
      />
    ));

    return (
      <React.Fragment>
        {this.state.redirectTo && <Redirect push to={this.state.redirectTo} />}
        {this.state.loading && <Loading />}
        <div className="row">
          <div className="col-md-12">
            <div className="alert alert-danger" role="alert" hidden={this.state.errors.length===0}>
              {this.state.errors.map((e, i) => <li key={i}><FormattedMessage {...(backendStrings[e] ? backendStrings[e] : backendStrings['errors.default'])}/></li>)}
            </div>
            <form className="form form-horizontal" ref="form" onSubmit={this.handleSubmit}>
              <div className="form-body">
                <div className="card pull-up">
                  <div className="card-content">
                    <div className="card-body">
                      <h4 className="form-section">
                        <i className="la la-hourglass-2"></i><FormattedMessage id="FormularioRecurrenciaAbm.render.general_data.header_datos_generales" defaultMessage=" Datos Generales "/><div className="float-right" style={{fontSize:'14px'}}>{ this.props.action === 'VIEW' ? '' : this.props.intl.formatMessage({ id: 'FormularioRecurrenciaAbm.render.general_data.campos_requeridos', defaultMessage: '* campos requeridos' }) }</div>
                      </h4>
                      <div className="row">
                        {/* Tipo Formulario */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-4 label-control col-form-label" htmlFor="tipo_formulario">
                              <FormattedMessage
                                id="FormularioRecurrenciaAbm.general_data.label_tipo_formulario"
                                defaultMessage="Tipo de Formulario *:"
                              />
                            </label>
                            <div className="col-md-8">
                              <Select.Async
                                name="tipo_formulario"
                                value={this.state.formData.tipo_formulario ? this.state.formData.tipo_formulario : null}
                                valueKey="id"
                                labelKey="nombre"
                                loadOptions={this.getBackendTipoForms}
                                onChange={this.handleTipoFormularioChange}
                                disabled={this.props.action === "VIEW"}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        {/* MOVIL */}
                        {formData.tipo_formulario && formData.tipo_formulario.con_movil ? (
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-4 label-control col-form-label text-nowrap" htmlFor="movil">
                              <FormattedMessage id="FormularioRecurrenciaAbm.render.general_data.label_movil" defaultMessage="Móvil"/>{requiredSymbol}:
                            </label>
                            <div className="col-md-8">
                              {this.props.action === 'VIEW' ? (
                              <div className="form-control-static col-form-label form-value">{formData.movil && formData.movil.dominio ? formData.movil.dominio : ''}</div>
                              ) : (
                              <div>
                                <Select.Async
                                  name="storageTypeId"
                                  value={this.state.formData.movil}
                                  valueKey="id"
                                  labelKey="dominio"
                                  loadOptions={this.getBackendMoviles}
                                  onChange={this.handleMovilChange}
                                  disabled={this.props.action === "VIEW"}
                                />
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                        ) : ( null )}
                        {/* PERSONA */}
                        {formData.tipo_formulario && formData.tipo_formulario.con_persona ? (
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-4 label-control col-form-label text-nowrap" htmlFor="persona">
                              <FormattedMessage id="FormularioRecurrenciaAbm.render.general_data.label_persona" defaultMessage="Persona"/>{requiredSymbol}:
                            </label>
                            <div className="col-md-8">
                              {this.props.action === 'VIEW' ? (
                              <div className="form-control-static col-form-label form-value">{formData.persona && formData.persona.nombre ? formData.persona.nombre + '' + formData.persona.apellido + ' (' + formData.persona.documentoTipo.nombre + ' ' + formData.persona.documentoNumero + ')'  : ''}</div>
                              ) : (
                              <div>
                                <Select.Async
                                  name="persona"
                                  value={this.state.formData.persona}
                                  valueKey="id"
                                  labelKey="label"
                                  loadOptions={this.getBackendPersonas}
                                  onChange={this.handlePersonaChange}
                                  disabled={this.props.action === "VIEW"}
                                />
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                        ) : ( null )}
                      </div>
                      <div className="row">
                        {/* RECURRENCIA */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-4 label-control col-form-label text-nowrap" htmlFor="recurrencia">
                              <FormattedMessage id="FormularioRecurrenciaAbm.render.recurrencia" defaultMessage="Recurrencia (días)"/>{requiredSymbol}:
                            </label>
                            <div className="col-md-8">
                              {this.props.action === 'VIEW' ? (
                              <div className="form-control-static col-form-label form-value">{formData.recurrencia === 0 ? '': formData.recurrencia }</div>
                              ) : (
                              <div>
                                <input 
                                  type="number"
                                  className="form-control"
                                  pattern="[0-9]*"
                                  min="0"
                                  id="recurrencia"
                                  name="recurrencia"
                                  placeholder={this.props.intl.formatMessage({ id: 'FormularioRecurrenciaAbm.render.avisos.placeholder_primer_alerta', defaultMessage: 'Sólo números' })}
                                  value={formData.recurrencia === 0 ? '' : formData.recurrencia}
                                  onInput={this.handleNumericChange.bind(this)}
                                />
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        {/* ACTIVO */}
                        <div className="col-md-6">
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group row">
                                <label className="col-md-8 label-control col-form-label text-nowrap" htmlFor="activo">
                                  <FormattedMessage id="FormularioRecurrenciaAbm.render.general_data.label_activo" defaultMessage="Activo:"/>
                                </label>
                                <div className="col-md-4 mt-auto">
                                  <Switch
                                    onChange={this.handleActivoChange}
                                    checked={formData.activo ? formData.activo : false}
                                    id="activo"
                                    name="activo"
                                    disabled={this.state.props.action === 'VIEW' ? true: false }
                                    offColor="#FF4961"
                                    onColor="#28D094"
                                  />
                                </div>
                              </div>
                            </div>
                            {/* RENOVACION */}
                            <div className="col-md-6">
                              <div className="form-group row">
                                <label className="col-md-8 label-control col-form-label text-nowrap" htmlFor="renovacion">
                                  <FormattedMessage id="FormularioRecurrenciaAbm.render.general_data.label_renovacion" defaultMessage="Ejecución por única vez:"/>
                                </label>
                                <div className="col-md-4 mt-auto">
                                  <Switch
                                    onChange={e => this.handleRenovacionChange(!e)}
                                    checked={!formData.renovacion}
                                    id="renovacion"
                                    name="renovacion"
                                    disabled={this.state.props.action === 'VIEW' ? true: false }
                                    offColor="#FF4961"
                                    onColor="#28D094"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card pull-up">
                  <div className="card-content">
                    <div className="card-body">
                      <h4 className="form-section">
                        <i className="la la-calendar"></i><FormattedMessage id="FormularioRecurrenciaAbm.render.vigencia.header_vigencia" defaultMessage=" Vigencia "/><div className="float-right" style={{fontSize:'14px'}}>{ this.props.action === 'VIEW' ? '' : this.props.intl.formatMessage({ id: 'vencimientosAbm.render.vigencia.campos_requeridos', defaultMessage: '* campos requeridos' }) }</div>
                      </h4>
                      <div className="row">
                        {/* FECHA DE VENCIMIENTO */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-4 label-control col-form-label" htmlFor="fecha_vencimiento">
                              <FormattedMessage id="FormularioRecurrenciaAbm.render.vigencia.label_fecha_de_vencimiento" defaultMessage="Fecha de Vencimiento"/>{requiredSymbol}:
                            </label>
                            <div className="col-md-8">
                              {this.props.action === 'VIEW' ? (
                              <div className="form-control-static col-form-label form-value">{formData.fecha_vencimiento === null || formData.fecha_vencimiento === '0000-00-00' ? '' : LocaleFormat.formatDate(formData.fecha_vencimiento)}</div>
                              ) : (
                              <div>
                                <DatePicker
                                  id="fecha_vencimiento"
                                  name="fecha_vencimiento"
                                  className="form-control date-picker-placeholder"
                                  dateFormat={LocaleFormat.getDatePickerFormat()}
                                  placeholderText={this.props.intl.formatMessage({ id: 'FormularioRecurrenciaAbm.render.general_data.placeholder_fecha_de_vencimiento', defaultMessage: 'DD/MM/AAAA' })}
                                  selected={formData.fecha_vencimiento === null || formData.fecha_vencimiento === '0000-00-00' ? '' : formData.fecha_vencimiento === '' ? formData.fecha_vencimiento = null : moment(formData.fecha_vencimiento)}
                                  onChange={(event) => this.handleDatePickerFormChange("fecha_vencimiento", event)}
                                  minDate={moment()}
                                  openToDate={moment()}
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                  autoComplete="off"
                                  customInput={<CustomInput />}
                                />
                                <div className="help-block text-danger field-message" hidden={validationState.formData.fecha_vencimiento.pristine || validationState.formData.fecha_vencimiento.valid}>{validationState.formData.fecha_vencimiento.message}</div>
                                <div className="help-block text-danger field-message" hidden={!formData.fechavencimiento_invalida == true}>Formato inválido</div>
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card pull-up">
                  <div className="card-content">
                    <div className="card-body">
                      <h4 className="form-section">
                        <i className="la la-bullhorn"></i><FormattedMessage id="FormularioRecurrenciaAbm.render.avisos.header_vigencia" defaultMessage=" Avisos "/>
                      </h4>
                      <div className="row">
                        {/* ALERTA DIAS PREVIOS */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-4 label-control col-form-label text-nowrap" htmlFor="alerta_dias_previos">
                              <FormattedMessage id="FormularioRecurrenciaAbm.render.avisos.label_primer_alerta" defaultMessage="Primer Alerta (dias antes):"/>
                            </label>
                            <div className="col-md-8">
                              {this.props.action === 'VIEW' ? (
                              <div className="form-control-static col-form-label form-value">{formData.alerta_dias_previos === 0 ? '': formData.alerta_dias_previos }</div>
                              ) : (
                              <div>
                                <input type="text" className="form-control" pattern="[0-9]*" id="alerta_dias_previos" name="alerta_dias_previos" placeholder={this.props.intl.formatMessage({ id: 'FormularioRecurrenciaAbm.render.avisos.placeholder_primer_alerta', defaultMessage: 'Sólo números' })} value={formData.alerta_dias_previos === 0 ? '': formData.alerta_dias_previos} onInput={this.handleNumericChange.bind(this)} />
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card pull-up">
                  <div className="card-content">
                    <div className="card-body">
                      <div className="text-cd text-right">
                        {this.props.action !== 'VIEW' && (
                        <button type="submit" className="btn btn-primary mr-1" disabled={!validationState.form.valid || isInvalidActivo}>
                          <i className="fa fa-check-circle"></i><FormattedMessage id="FormularioRecurrenciaAbm.finish_button.guardar" defaultMessage=" Guardar"/>
                        </button>
                        )}
                        <button type="button" className="btn btn-danger" onClick={this.handleCancel.bind(this)}>
                          <i className="fa fa-times-circle"></i> {this.props.action === 'VIEW' ? this.props.intl.formatMessage({ id: 'FormularioRecurrenciaAbm.finish_button.volver', defaultMessage: 'Volver' }) : this.props.intl.formatMessage({ id: 'FormularioRecurrenciaAbm.finish_button.cancelar', defaultMessage: 'Cancelar' })}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default injectIntl(FormularioRecurrenciaAbm);
